import React from 'react';
import { Box, InputAdornment } from '@mui/material';
import { Button } from '../..';
import { TextField } from '../TextField';
import { Typography } from '../Typography';

export interface DisplayTextFieldButtonProps {
  value: string;
  buttonLabel: string;
  onButtonClick: (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  size?: 'small' | 'medium';
  error: boolean;
  helperText?: string;
  label: string;
  leftSlot?: React.ReactNode;
  inputAriaLabel?: string;
  buttonAriaLabel?: string;
  id?: string;
}
export const DisplayTextFieldButton: React.FC<DisplayTextFieldButtonProps> = ({
  value,
  size = 'medium',
  error,
  helperText = '',
  buttonLabel,
  onButtonClick,
  label,
  leftSlot,
  inputAriaLabel,
  buttonAriaLabel,
  id,
}: DisplayTextFieldButtonProps) => {
  return (
    <TextField
      size={size}
      error={error}
      id={id}
      disabled={true}
      helperText={helperText}
      value={value}
      inputAriaLabel={inputAriaLabel}
      inputStyles={{
        '& input': {
          paddingLeft: '0 !important',
          fontWeight: '500',
          height: '24px',
          borderRight: '1px solid #D0D5DD',
          '&:disabled': {
            borderRight: '1px solid #D0D5DD !important',
            borderRadius: '0 !important',
          },
        },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                backgroundColor: '#F2F4F7',
                borderRadius: '8px 0 0 8px',
                height: size == 'small' ? '39px' : '48px',
                marginLeft: 0,
                marginRight: 0,
              }}
            >
              <InputAdornment position="start">
                {leftSlot}
                <Typography variant="body1" sx={{ color: '#414651' }}>
                  {label}:
                </Typography>
              </InputAdornment>
            </Box>
          ),
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{
                marginRight: '0 !important',
                marginLeft: '0 !important',
                backgroundColor: '#fff',
                borderRadius: '0 8px 8px 0 ',
              }}
            >
              <Button
                size={size}
                variant="text"
                aria-label={buttonAriaLabel}
                color="secondary"
                sx={{ color: '#414651 !important' }}
                onClick={(ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                  ev.stopPropagation();
                  onButtonClick(ev);
                }}
              >
                {buttonLabel}
              </Button>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
